export default __webpack_public_path__ + "static/media/img-egt-klm@3x.1e51b80b.png";